import { defineComponent, ref, watchEffect } from 'vue'
import { useTransition } from '@vueuse/core'
import useHasIntersected from '/src/composables/use-has-intersected'
import { timeline } from 'motion'

const DURATION = 4 // in seconds
const EASING = /** @type {[number, number, number, number]} */ ([0.25, 0.1, 0.25, 1.0])

export default defineComponent({
    setup(props) {
        const el = ref(/** @type {HTMLElement?} */(null))
        const toYear = ref(/** @type {HTMLElement?} */(null))
        const graph = ref(/** @type {HTMLElement?} */(null))
        const highlight = ref(/** @type {HTMLElement?} */(null))
        const hasIntersected = useHasIntersected(el)
        const inputYear = ref(props.fromYear)
        const year = useTransition(inputYear, {
            duration: DURATION * 1000,
            transition: EASING
        })
        const inputValues = ref(/** @type {number[]} */(props.fromValues))
        const values = useTransition(inputValues, {
            duration: DURATION * 1000,
            transition: EASING
        })

        const unwatch = watchEffect(() => {
            if (!hasIntersected.value || !graph.value || !highlight.value || !toYear.value) return

            // Kick off transitions
            inputYear.value = props.toYear
            inputValues.value = /** @type {number[]} */(props.toValues)
            timeline([
                [graph.value, {
                    clipPath: 'inset(0)'
                }, {
                    duration: DURATION,
                    easing: EASING,
                }],
                [highlight.value, {
                    clipPath: 'inset(0)'
                }, {
                    duration: DURATION / 5,
                    easing: EASING,
                    at: DURATION / 5
                }],
                [toYear.value, {
                    transform: 'none',
                }, {
                    duration: DURATION,
                    easing: EASING,
                    at: 0
                }],
                [toYear.value, {
                    opacity: [0, 1, 1]
                }, {
                    duration: DURATION,
                    easing: EASING,
                    offset: [0, 0.5, 1],
                    at: 0
                }]
            ])

            unwatch()
        })

        return {
            el,
            year,
            toYear,
            graph,
            highlight,
            values,
            numberFormatter: new Intl.NumberFormat('en-US', {
                maximumFractionDigits: 1,
            }),
        }
    },
    props: {
        fromYear: {
            type: Number,
            required: true
        },
        toYear: {
            type: Number,
            required: true
        },
        fromValues: {
            type: Array,
            required: true
        },
        toValues: {
            type: Array,
            required: true
        },
    }
})